export default __webpack_public_path__ + "static/media/case2 (6).b1c4ef92.jpg";